import { Steps } from 'antd';
import styled from 'styled-components';

export const WizardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const WizardStepsSection = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: ${({ $isMobile }) => ($isMobile ? '12px 20px' : '12px 40px')};
  border-bottom: 1px solid var(--light-pink);
  box-shadow: 0 2px 8px rgba(35, 37, 103, 0.08);

  ${({ $isMobile }) =>
    $isMobile &&
    `
    overflow-x: auto;
    overflow-y: hidden;

    // Fills the width like on desktop, but never narrower than its steps -
    // past that the section scrolls sideways instead of squashing them
    .ant-steps {
      flex: 1 0 auto;
      min-width: max-content;
      flex-wrap: nowrap;
    }

    .ant-steps-item-title {
      white-space: nowrap;
      font-size: 13px;
    }

    // Room for the connector line (drawn right after each title) even at
    // the steps' narrowest
    .ant-steps-item:not(:last-child) .ant-steps-item-content {
      padding-inline-end: 24px;
    }
  `}
`;

export const WizardSteps = styled(Steps)<{ $stepMinWidth: number }>`
  width: auto;

  .ant-steps-item-content {
    min-width: ${({ $stepMinWidth }) => $stepMinWidth}px;
  }
`;

export const WizardStepContent = styled.div<{
  $disablePadding?: boolean;
  $isMobile?: boolean;
}>`
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  min-height: 0;

  ${({ $disablePadding, $isMobile }) =>
    $disablePadding
      ? `
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  `
      : `
    padding: ${$isMobile ? '20px' : '24px 40px 40px'};
    overflow: auto;
  `}
`;

export const WizardFooter = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: ${({ $isMobile }) => ($isMobile ? '12px 20px' : '12px 40px')};
  border-top: 1px solid var(--light-pink);
  box-shadow: 0 -2px 8px rgba(35, 37, 103, 0.08);

  .wizard-prev-btn {
    border: 1px solid var(--primary);
  }
`;
